<template>
  <div class="ob1-promotional-code-content">
    <input
      id="promotional-code-input"
      v-model="inputValue"
      :aria-labelledby="ariaLabelledBy"
      type="text"
      data-ob1-component="FormControlEmpty"
      :class="['form-control', { 'form-control-empty': isEmpty, 'form-focus-visible': hasFocus, 'is-invalid': isInvalid }]"
      :aria-invalid="isInvalid"
      data-wptv="input-code-promo"
      @focus="onInputFocus()"
      @blur="onInputBlur()">
    <label
      id="promotional-code-label"
      for="promotional-code-input"
      class="form-control-placeholder"
      data-wptv="label-code-promo">{{ label }}</label>
    <div
      v-if="helperText"
      id="promotional-code-helper"
      class="form-control-help"
      data-wptv="helper-text-code-promo">
      {{ helperText }}
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PromotionalCodeContent',
  props: {
    label: {
      type: String,
      required: true
    },
    helperText: {
      type: String,
      default: null
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hasFocus: false,
      inputValue: ''
    }
  },
  computed: {
    isEmpty () {
      return this.inputValue === ''
    },
    input () {
      return this.inputValue
    },
    ariaLabelledBy () {
      return this.isInvalid ? 'promotional-code-invalid-feedback' : 'promotional-code-label'
    }
  },
  watch: {
    inputValue (newInput, oldInput) {
      if (newInput !== '') {
        this.$emit('input-focus')
      }
      if (newInput !== oldInput) {
        this.$emit('input-update')
      }
    }
  },
  methods: {
    clear () {
      this.inputValue = ''
    },
    onInputFocus () {
      this.hasFocus = true
      this.$emit('input-focus')
    },
    onInputBlur () {
      this.hasFocus = false

      if (this.isEmpty) {
        this.$emit('input-blur-and-empty')
      }
    }
  }
}
</script>
